import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import css from './NestMarkerPopup.module.css';
import Directions from "../Directions";
import pokedex from "../../../utils/pokedex";

const NestMarkerPopup = (props) => {
	return (<div className={css.NestMarkerPopup}>
		<div className={css.HeaderLine}>
			{props.nest.name}
		</div>

		{props.nest.pokemon_id &&
			<div className={css.SpeciesLine}>
				Current nest: <span>{pokedex[props.nest.pokemon_id]['name']}</span>
			</div>
		}

		<Directions id={props.id} latitude={props.nest.nest_latitude} longitude={props.nest.nest_longitude} />
	</div>);
};

NestMarkerPopup.propTypes = {
	nest: PropTypes.object.isRequired
};

const mapStateToProps = (state) => {
	return {
		moves: state.core.moves,
		discordUser: state.core.discordUser
	};
};

export default connect(mapStateToProps)(NestMarkerPopup);